import Colors from "@constants/Colors";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import styled from "styled-components";

export const StyledLoader = styled(Box)`
  width: 100%;
  text-align: center;
  display: flex;
  height: 100%;
  flex-direction: column;
  text-align: center;
  justify-content: space-around;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: auto;
`;

export const StyledCircularProgresss = styled(CircularProgress)`
  .MuiCircularProgress-root {
    color: ${Colors.neutral_gray_500} !important;
  }
`;
